import { ISubmitSearch } from '../../interfaces/submit-search.interface';
import { IBusquedaAutoComplete } from '../../interfaces/busqueda-autocomplete.interface';
import { map, catchError } from 'rxjs/operators';
import { HomeService } from '../../services/home.service';
import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { CONSTANTS } from '@app/core';
// import { FiltroUniversidadService } from '@app/core/services/filtro-universidad.service';
// import { FiltroCarreraService } from '@app/core/services/filtro-carrera.service';
// import { LoaderService } from './../../../../shared/services/loader.service';

enum ICONOS {
  UNIVERSIDAD = 'siu-ico-universidad-anaranjado-claro',
  CARRERA = 'siu-ico-carrera-morado-claro'
};

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  cantidadUniversidades$: Observable<number>;
  cantidadCarreras$: Observable<number>;  
  constructor(
    // private loader: LoaderService,
    private homeService: HomeService,
    private router: Router,
    // private filtroUniversidadService: FiltroUniversidadService, 
    // private filtroCarreraService: FiltroCarreraService
  ) { }

  ngOnInit() {
    this.loadCantidades();
  }

  loadCantidades = () => {
    // this.filtroCarreraService.resetData();
    // this.filtroUniversidadService.resetData();
    // this.cantidadUniversidades$ = this.homeService.getCantidadUniversidades().pipe(
    //   map(resp => resp.data.cantidad), catchError(err => of(0))

    // );
    // this.cantidadCarreras$ = this.homeService.getCantidadCarreras().pipe(
    //   map(resp => resp.data.cantidad), catchError(err => of(0))
    // );
  }



  // ===========================================================
  // #region METHODS
  // ===========================================================



  // ===========================================================
  // #endregion
  // ===========================================================






  // ===========================================================
  // #region HANDLER METHODS
  // ===========================================================

  handleSubmitBuscador = (e: ISubmitSearch) => {

    let route = '';

    switch (e.tipo) {
      case 1: default:
        route = '/universidades';
        break;
      case 2:
        route = '/programas';
        break;
    }

    this.router.navigate([route], { queryParams: { term: e.term } });

  }

  handleSelectItemBusqueda = (item: IBusquedaAutoComplete) => {
    let route = '';

    switch (item.tipo) {
      case 1: default:
        //route = `/universidades/${item.id}`;
        route = `/universidades`;
        break;
      case 2:
        //route = `/carreras/${item.id}`;
        route = `/programas`;
        break;
    }
    this.router.navigate([route], { queryParams: { term: item.descripcion } });
  };

  handleSearchBuscador = (term, tipo, filters): Observable<Array<IBusquedaAutoComplete>> => {

    const obervable = (tipo == 1 ? this.homeService.searchUniversidades(term, filters) : this.homeService.searchCarreras(term, filters));

    return obervable.pipe(
      map(
        resp => resp.data.length == 0 ? [{ descripcion: 'No se encontraron resultados', id: -1, tipo: 0 }] : resp.data.map(x => ({
          ...x,
          icono: (x.tipo == 1 ? ICONOS.UNIVERSIDAD : ICONOS.CARRERA)
        })
        )
      )
    );
  }
  // ===========================================================
  // #endregion
  // ===========================================================

}
